export const doOtaUpdate = async (alert?: false) => {};
